import { Box, Grid, Typography } from '@mui/material';
import { Control, FieldError, FieldErrors, useWatch } from 'react-hook-form';
import DateInput from '../../../../MUIComponents/DateInput';
import { WorkExperienceFormInputs } from '../WorkExperience';

interface TimeLineInputsProps {
  index: number;
  label: string;
  control: Control<WorkExperienceFormInputs, any>;
  errors: FieldErrors<WorkExperienceFormInputs>;
  onFieldChange?: (field: keyof WorkExperienceFormInputs, value: any) => void;
  disabled?: boolean;
}

const TimeLineInputs = ({
  index,
  label,
  control,
  errors,
  onFieldChange: _onFieldChange,
  disabled,
}: TimeLineInputsProps) => {
  const isActiveWork = useWatch({
    control,
    name: `workExperiences.${index}.activeWork`,
  });

  return (
    <>
      <Box display="flex" flexDirection="column">
        <Typography variant="body4" fontWeight={700} padding={'0 2px'}>
          {!isActiveWork ? label : 'Time of work'}
        </Typography>
        <Grid
          container
          sx={(theme) => ({
            display: 'flex',
            gap: '1.375rem',
            [theme.breakpoints.down('md')]: {
              gridColumn: 'span 2',
              display: 'block',
              gap: '1rem',
            },
          })}
        >
          <Grid
            item
            sx={(theme) => ({
              width: 184,
              [theme.breakpoints.down('md')]: {
                width: '100%',
              },
            })}
          >
            <DateInput<WorkExperienceFormInputs>
              control={control}
              name={`workExperiences.${index}.startDate`}
              error={errors.workExperiences?.[index]?.startDate as FieldError}
              helperText={
                errors.workExperiences?.[index]?.startDate?.message || ''
              }
              placeholder="Your start date"
              // onChange={value => onFieldChange?.('startDate', dayjs(value))}
              disabled={disabled}
            />
          </Grid>
          {!isActiveWork && (
            <Grid
              item
              sx={(theme) => ({
                width: 184,
                [theme.breakpoints.down('md')]: {
                  width: '100%',
                },
              })}
            >
              <DateInput<WorkExperienceFormInputs>
                control={control}
                name={`workExperiences.${index}.endDate`}
                error={errors.workExperiences?.[index]?.endDate as FieldError}
                helperText={
                  errors.workExperiences?.[index]?.endDate?.message || ''
                }
                placeholder="Your end date"
                // onChange={value => onFieldChange?.('endDate', dayjs(value))}
                disabled={disabled}
              />
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
};

export default TimeLineInputs;
